export function getLinkTarget(isEmail: boolean, href: string): '_self' | '_blank' {
  if (isEmail) return '_blank'
  if (href.startsWith('https://secure') || href.startsWith('/')) return '_self'
  return '_blank'
}